<template>
    <soft-alert v-show="userDeleted === true" color="success" icon="ni ni-like-2 ni-lg" dismissible>
      <strong>Success</strong> User deleted!
    </soft-alert>
    <soft-alert v-show="userNotDeleted === true" color="danger" icon="ni ni-dislike-2 ni-lg" dismissible>
      <strong>Error</strong> User couldn't be deleted!
    </soft-alert>
    <soft-alert v-show="userCannotDelete === true" color="danger" icon="ni ni-dislike-2 ni-lg" dismissible>
      <strong>You cannot delete your user</strong>
    </soft-alert>
    <soft-alert v-show="showResponseMessage2 === true" color="danger" icon="ni ni-unlike-2 ni-lg" dismissible>
      <strong> {{ responseMessage2 }} </strong>
    </soft-alert>

  <div class="card">
    <div class="card-header pb-0 mb-4">
      <div style="display: flex; align-items: center; justify-content: space-between;">
        <div style="display: flex;
          gap: 10px;
          align-items: baseline;">
          <h6 style="margin: 0"><span style="color: #cb0c9f;font-weight: 600;">{{K.fNumber(datos.length)}}</span> <span v-if="datos.length !== 1">Users</span><span v-else>User</span></h6>

          
        </div>
        <div>
          <SoftButton data-bs-toggle="modal" data-bs-target="#exampleModal" @click="refreshTeams()">
            New User
          </SoftButton>
        </div>
      </div>
    </div>
    <div class="card-body px-0 pb-2" style="max-height: 430px; height: 430px; overflow-y: scroll; padding: 15px !important;">
      <div class="table-responsive" style="min-width: 1000px;">
        <table class="table align-items-center mb-0">
          <thead>
            <tr>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >
                Email
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
              >
                Last session
              </th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >
                Emails sent today
              </th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >
                Emails sent last month
              </th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >
                Type of user
              </th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >
                Team
              </th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >
                Options
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in datos" v-bind:key="row">
              <td style="overflow: hidden;">
                <div class="d-flex px-2 py-1">
                  <div class="d-flex flex-column justify-content-center">
                    <h6 class="mb-0 text-sm">{{ row.email }}</h6>
                  </div>
                </div>
              </td>
              <td class="align-middle">
                <span v-if="row.last_login !== null" class="text-secondary text-xs font-weight-bold">
                  {{ formatDate(row.last_login) }}
                </span>
                <span v-else class="text-secondary text-xs font-weight-bold">
                  No login
                </span>
              </td>
              <td class="align-middle text-center text-sm">
                <span class="text-xs font-weight-bold">{{ K.fNumber(row.generaciones_user_day) }}</span>
              </td>
              <td class="align-middle text-center text-sm">
                <span class="text-xs font-weight-bold">{{ K.fNumber(row.generaciones_user_month) }}</span>
              </td>
              <td class="align-middle text-center text-sm">
                <span class="text-xs font-weight-bold" style="padding: 5px; background-color: #cb0c9f; color: #fff; border-radius: 20px;">
                  {{ row.permision }}
                </span>
              </td>
              <td class="align-middle text-center text-sm">
                <span class="text-xs font-weight-bold" style="padding: 5px; background-color: #cb0c9f; color: #fff; border-radius: 20px;">
                  {{ Object.keys(row.collections).join(', ') }}
                </span>
              </td>
              <td class="align-middle text-center">
                <!--<a class="btn text-secondary font-weight-bold text-xs">
                  <i class="fas fa-pen"></i>
                </a>-->
                <a @click="openDeleteModal(row.token)" data-bs-toggle="modal" data-bs-target="#idDeleteUser"
                  class="btn text-secondary font-weight-bold text-xs"
                  data-toggle="tooltip"
                  data-original-title="Delete user">
                  <i style="color: red;" class="fas fa-trash"></i>
              </a>
              </td>
            </tr>
            
          </tbody>
        </table>
      </div>
    </div>

    <!-- Modal New User-->
    <div class="modal fade" data-bs-backdrop="static" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">New user</h5>
            
          </div>
          <div class="modal-body">
            <label>Email</label>
            <input
              id="email"
              type="email"
              class="form-control"
              name="email"
              v-model="email"
              placeholder="Email"
              isRequired="required"
            />
            <label>Password</label>
            <input
              id="password"
              type="text"
              class="form-control"
              name="password"
              v-model="password"
              placeholder="Password"
              isRequired="required"
            />
            <label>Teams</label>
            <Multiselect
            style="border-radius: 0.5rem; "
              v-model="multipleSelect.value"
              v-bind="multipleSelect"
              placeholder="Select one or more teams"
            ></Multiselect>

            <label>Role of user</label>
            <Multiselect
            style="border-radius: 0.5rem; "
              v-model="userRole.value"
              v-bind="userRole"
              placeholder="Select a user role"
            ></Multiselect>
            <br>
          </div>
          <div class="modal-footer">
            <SoftButton id="botonCerrarNewUser" type="button" color="secondary" data-bs-dismiss="modal">Close</SoftButton>
            <SoftButton @click="newUser()">Save changes</SoftButton>
          </div>
        </div>

        <soft-alert v-show="notEmail === true" color="danger" icon="ni ni-dislike-2 ni-lg" dismissible>
          <strong>Error</strong> Email field must not be empty
        </soft-alert>
        <soft-alert v-show="notPassword === true" color="danger" icon="ni ni-dislike-2 ni-lg" dismissible>
          <strong>Error</strong> Password field must not be empty
        </soft-alert>
        <soft-alert v-show="userNotCreated === true" color="danger" icon="ni ni-dislike-2 ni-lg" dismissible>
          <strong>No team selected</strong> Select a team before creating the user, try again!
        </soft-alert>
        
        <soft-alert v-show="userNotCreatedName === true" color="danger" icon="ni ni-dislike-2 ni-lg" dismissible>
          <strong>Username already exists</strong> Change the username and try again!
        </soft-alert>
        <soft-alert v-show="validEmail === true" color="danger" icon="ni ni-dislike-2 ni-lg" dismissible>
          <strong>Enter a valid email address</strong>
        </soft-alert>
        <soft-alert v-show="notRole === true" color="danger" icon="ni ni-dislike-2 ni-lg" dismissible>
          <strong>You must assign a role to the user</strong>
        </soft-alert>
        <soft-alert v-show="showResponseMessage === true" color="danger" icon="ni ni-unlike-2 ni-lg" dismissible>
          <strong> {{ responseMessage }} </strong>
        </soft-alert>
      </div>
    </div>

    <!-- Modal Delete User-->
    <div class="modal fade" data-bs-backdrop="static" id="idDeleteUser" tabindex="-1" aria-labelledby="deleteUserLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Delete user</h5>
            
          </div>
          <div class="modal-body">
            Your are about to delete a user
          </div>
          <div class="modal-footer">
            <SoftButton color="secondary" data-bs-dismiss="modal">Close</SoftButton>
            <SoftButton color="danger" @click="deleteUser()" data-bs-dismiss="modal">Delete</SoftButton>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import setTooltip from "@/assets/js/tooltip.js";
  import HTFetch from "../../llamadas/HTFetch"
  import SoftButton from "../../components/SoftButton.vue"
  import SoftAlert from "@/components/SoftAlert.vue";
  import Multiselect from '@vueform/multiselect'
  import K from "../../llamadas/K"
  //import Modal from '../../../node_modules/bootstrap/js/src/modal.js'

  export default {
    name: "activityTable",
    
    props: {
      datos: {
        type: Array,
        required: true,
      }
    },

    watch: {
      datos() {
        
      }
      
    },

    data() {
      return {
        llamada: new HTFetch(),
        K: new K(),
        email: "",
        password: "",
        notEmail: false,
        notPassword: false,
        userDeleted: false,
        userNotDeleted: false,
        userCannotDelete: false,
        userNotCreated: false,
        userNotCreatedName: false,
        notRole: false,
        validEmail: false,
        deleteToken: "",
        typeUser: "",
        value: [],
        collections: [],
        multipleSelect: {
          mode: 'tags',
          value: [],
          closeOnSelect: false,
          options: [
            { value: 'batman', label: 'Batman' },
            { value: 'robin', label: 'Robin' },
            { value: 'joker', label: 'Joker' },
          ],
          canClear: false,
          canDeselect: false
        },
        userRole: {
          value: [],
          closeOnSelect: true,
          options: [
            { value: 'manager', label: 'Manager (can generate and manage new mails, and access the dashboard)' },
            { value: 'inserter', label: 'Inserter (can generate and manage new mails)' },
            { value: 'user', label: 'User (can only generate mails)' },
          ],
          canClear: false,
          canDeselect: false
        },
        responseMessage: "",
        showResponseMessage: false,
        responseMessage2: "",
        showResponseMessage2: false,
      };
    },

    components: {
      SoftButton,
      SoftAlert,
      Multiselect
    },

    mounted() {
      setTooltip();
      this.refreshTeams()
    },

    methods: {

      openDeleteModal(token) {
        this.deleteToken = token
      },

      deleteUser() {
        
        if (this.datos.length < 2) {
          
          if (this.datos[0].permision === 'manager') {
            this.userCannotDelete = true

            setTimeout(() => {
              this.userCannotDelete = false
            }, 2000)

            return
          }
        }

        let body = {
          'token': this.deleteToken
        }

        this.llamada.deleteUser(body, this.deleteUserRsp.bind(this))
      },

      deleteUserRsp(rsp) {
        if (399 < rsp.status && rsp.status < 501) {
          if ('detail' in rsp.data) {
            this.responseMessage2 = rsp.data.detail.toString().replace("'", "").replace("[", "").replace("]", "")
          }

          if ('Message' in rsp.data) {
            this.responseMessage2 = rsp.data.Message.toString().replace("'", "").replace("[", "").replace("]", "")
          }

          if ('message' in rsp.data) {
            this.responseMessage = rsp.data.message.toString().replace("'", "").replace("[", "").replace("]", "")
          }

          if ('Error' in rsp.data) {
            this.responseMessage2 = rsp.data.Error.toString().replace("'", "").replace("[", "").replace("]", "")
          }
          
          this.showResponseMessage2 = true

          setTimeout(() => {
            this.showResponseMessage2 = false
          }, 5000)

          return
        }

        if (rsp.data.message === 'Deleted') {
          this.userDeleted = true

          setTimeout(() => {

            this.userDeleted = false
          }, 2000)

          this.$emit("traerdata")

        }
      },

      refreshTeams() {
        this.collections = JSON.parse(localStorage.collections)
        let colecciones = JSON.parse(localStorage.collections)
        const updatedArray = colecciones.map(obj => {
          return {
            label: obj.name,
            value: obj.token
          };
        });

        this.multipleSelect.options = updatedArray
      },

      newUser() {
        if (this.email.length === 0) {
          this.notEmail = true

          setTimeout(() => {
            this.notEmail = false
          }, 2000)
          return
        }
        if (this.password.length === 0) {
          this.notPassword = true

          setTimeout(() => {
            this.notPassword = false
          }, 2000)
          return
        }

        if (this.multipleSelect.value.length === 0) {
          this.userNotCreated = true

          setTimeout(() => {
            this.userNotCreated = false
          }, 5000)
          return
        }

        if (this.userRole.value.length === 0) {
          this.notRole = true

          setTimeout(() => {
            this.notRole = false
          }, 5000)
          return
        }

        let body = {
          'email': this.email,
          'username': this.email,
          'password': this.password,
          'asigned_permision': this.userRole.value,
          "asigned_collections": this.multipleSelect.value//teamsSelected
        }

        this.llamada.newUser(body, this.newUserRsp.bind(this))
      },

      newUserRsp(rsp) {
        if (399 < rsp.status && rsp.status < 501) {
          if ('detail' in rsp.data) {
            this.responseMessage = rsp.data.detail.toString().replace("'", "").replace("[", "").replace("]", "")
          }

          if ('Message' in rsp.data) {
            this.responseMessage = rsp.data.Message.toString().replace("'", "").replace("[", "").replace("]", "")
          }

          if ('message' in rsp.data) {
            this.responseMessage = rsp.data.message.toString().replace("'", "").replace("[", "").replace("]", "")
          }

          if ('Error' in rsp.data) {
            this.responseMessage = rsp.data.Error.toString().replace("'", "").replace("[", "").replace("]", "")
          }

          if ("email" in rsp.data) {
            this.responseMessage = rsp.data.email.toString().replace("'", "").replace("[", "").replace("]", "")
          }

          if ("username" in rsp.data) {
            this.responseMessage = rsp.data.username.toString().replace("'", "").replace("[", "").replace("]", "")
          }
          
          this.showResponseMessage = true

          setTimeout(() => {
            this.showResponseMessage = false
          }, 5000)

          return
        }

        if ("username" in rsp.data) {
          if (rsp.data.username[0] === 'A user with that username already exists.') {
            this.userNotCreatedName = true

            setTimeout(() => {
              this.userNotCreatedName = false
            }, 5000)
            return
          }
        }
        
        if ("email" in rsp.data) {
          if (rsp.data.email[0] === 'Enter a valid email address.') {
            this.validEmail = true

            setTimeout(() => {
              this.validEmail = false
            }, 5000)
            return
          }
        }

        var myModalEl = document.getElementById('botonCerrarNewUser');
        myModalEl.click();
        
        this.email = "";
        this.password = "";
        this.userRole.value = [];
        this.multipleSelect.value = [];

        this.$emit("traerdata")
      },

      formatDate(date) {
        const fecha = new Date(date);

        const year = fecha.getFullYear();
        const month = ("0" + (fecha.getMonth() + 1)).slice(-2);
        const day = ("0" + fecha.getDate()).slice(-2);
        const hours = ("0" + fecha.getHours()).slice(-2);
        const minutes = ("0" + fecha.getMinutes()).slice(-2);
        const seconds = ("0" + fecha.getSeconds()).slice(-2);

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      }
    }
  };
</script>

<style src="@vueform/multiselect/themes/default.css"></style>
